import React, { useEffect } from "react";
import { RewardFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import QRCode from "react-qr-code";
import { Inputs, Buttons } from "components";

const RewardForm = ({
  initialValues,
  permission,
  onSubmit,
  onCancel,
  onDelete,
}) => {
  const schema = yup.object().shape({
    name: yup.string().required("Reward Name is required"),
    description: yup.string().required("Description Name is required"),
    type: yup.string().required("Reward Type is required"),
  });

  const {
    control,
    // watch,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  // const watchCampaignType = watch('type');

  useEffect(() => {
    if (initialValues) {
      reset({
        ...initialValues,
        expired_at: new Date(initialValues.expired_at),
        start_date:
          initialValues.start_date && new Date(initialValues.start_date),
        end_date: initialValues.end_date && new Date(initialValues.end_date),
        img_file: initialValues.img ? [{ media_uri: initialValues.img }] : [],
        time_to_use: String(initialValues.time_to_use),
        reward_limit_per_user: String(initialValues.reward_limit_per_user),
      });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const _handleSubmit = (values) => {
    let isErr = false;
    if (values.passcode_type && !values.single_passcode) {
      isErr = true;
      setError("single_passcode", {
        type: "custom",
        message: "Passcode is required",
      });
    }
    if (!isErr) {
      onSubmit(values);
    }
  };

  return (
    <RewardFormStyled>
      <form onSubmit={handleSubmit(_handleSubmit)}>
        <div className="body_form_campaign">
          <div className="input_type_wrap">
            <div className="itw_left_box">Reward type</div>
            <div className="itw_right_box ">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    disabled={initialValues ? true : false}
                    options={[
                      // {
                      //   value: "1",
                      //   label: "E-Coupon",
                      // },
                      {
                        value: "4",
                        label: "E-Voucher",
                      },
                      // {
                      //   value: "2",
                      //   label: "Voucher",
                      // },
                      // {
                      //   value: "3",
                      //   label: "Gift",
                      // },
                      // {
                      //   value: "5",
                      //   label: "Premium",
                      // },
                    ]}
                    errors={errors.type?.message}
                  />
                )}
                name="type"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Reward Code:</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      errors={errors.reward_code?.message}
                    />
                  )}
                  name="reward_code"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Reward name:</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      errors={errors.name?.message}
                    />
                  )}
                  name="name"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Reward description:</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextArea
                      {...field}
                      errors={errors.description?.message}
                    />
                  )}
                  name="description"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          {/* <div className="input_type_wrap">
            <div className="itw_left_box">Business Unit</div>
            <div className="itw_right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    disabled={initialValues ? true : false}
                    options={[
                      {
                        value: "1",
                        label: "Service",
                      },
                    ]}
                    errors={errors.business_unit?.message}
                  />
                )}
                name="business_unit"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div> */}
          <div className="input_warp">
            <div className="left_box">Expired at:</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.DateTime
                      {...field}
                      placeholder={"วันที่สิ้นสุด"}
                      errors={errors.expired_at?.message}
                      showYearDropdown
                    />
                  )}
                  name="expired_at"
                  defaultValue={new Date()}
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Start Date:</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.DateTime
                      {...field}
                      placeholder={"Start Date"}
                      errors={errors.start_date?.message}
                      showYearDropdown
                    />
                  )}
                  name="start_date"
                  defaultValue={new Date()}
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">End Date:</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.DateTime
                      {...field}
                      placeholder={"End Date"}
                      errors={errors.end_date?.message}
                      showYearDropdown
                    />
                  )}
                  name="end_date"
                  defaultValue={new Date()}
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Total amount(จำนวนที่แจก)</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      type="number"
                      disabled={initialValues ? true : false}
                      min={0}
                      errors={errors.total_amount?.message}
                    />
                  )}
                  name="total_amount"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="line" />
          <div className="input_type_wrap">
            <div className="itw_left_box">วิธีในการแจก/ได้รับ</div>
            <div className="itw_right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    disabled={initialValues ? true : false}
                    options={[
                      // {
                      //   label: "ระบบคะแนน",
                      //   value: "1",
                      // },
                      {
                        label:
                          "SERVICE ONLY - Code Redeem/QR code/Add by admin ",
                        value: "2",
                      },
                    ]}
                    errors={errors.distribution_method?.message}
                  />
                )}
                name="distribution_method"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">จำนวนครั้ง รับรางวัล ต่อ 1 คน</div>
            <div className="itw_right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    disabled={initialValues ? true : false}
                    options={[...Array(5)].map((_, i) => ({
                      value: (i + 1).toString(),
                      label: (i + 1).toString(),
                    }))}
                    errors={errors.reward_limit_per_user?.message}
                  />
                )}
                name="reward_limit_per_user"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">วิธีการใช้</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.Dropdown
                      {...field}
                      disabled={initialValues ? true : false}
                      options={[
                        // {
                        //   value: "1",
                        //   label: "เก็บ แล้วกดใช้",
                        // },
                        // {
                        //   value: "2",
                        //   label: "แลกคะแนน จัดส่ง รับของ",
                        // },
                        {
                          value: "3",
                          label: "ตัดในระบบ service odoo",
                        },
                      ]}
                      errors={errors.usage_method?.message}
                    />
                  )}
                  name="usage_method"
                  // defaultValue={{ label: '1', value: '1' }}
                />
              </div>
            </div>
          </div>
          <div className="input_type_wrap">
            <div className="itw_left_box">Time to use</div>
            <div className="itw_right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.Dropdown
                    {...field}
                    disabled={initialValues ? true : false}
                    options={[...Array(10)].map((_, i) => ({
                      value: (i + 1).toString(),
                      label: (i + 1).toString(),
                    }))}
                    errors={errors.time_to_use?.message}
                  />
                )}
                name="time_to_use"
                // defaultValue={{ label: '1', value: '1' }}
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">มูลค่า(Price)</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      type="number"
                      min={0}
                      errors={errors.price?.message}
                    />
                  )}
                  name="price"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Passcode</div>
            <div className="right_box center">
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.Radio
                      {...field}
                      options={[
                        {
                          label: "Single Passcode",
                          value: "1",
                        },
                      ]}
                      errors={errors.passcode_type?.message}
                    />
                  )}
                  name="passcode_type"
                  defaultValue=""
                />
              </div>
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.TextField
                      {...field}
                      disabled={initialValues ? true : false}
                      type="text"
                      errors={errors.single_passcode?.message}
                    />
                  )}
                  name="single_passcode"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">QR code</div>
            <div className="right_box center">
              <div className="w20">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.Radio
                      {...field}
                      disabled={initialValues ? true : false}
                      options={[
                        {
                          label: "SingleQR code",
                          value: "2",
                        },
                      ]}
                      errors={errors.qrcode_type?.message}
                    />
                  )}
                  name="qrcode_type"
                  defaultValue=""
                />
              </div>
            </div>
          </div>
          <div className="line" />
          <div className="input_warp">
            <div className="left_box">Image</div>
            <div className="right_box">
              <div className="w50">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <Inputs.UploadImage
                      {...field}
                      theme_upload_image
                      acceptType={"cover"}
                      scaleLabel="*** รูปขนาดกว้าง 197px สูง 148px"
                      errors={errors.img_file?.message}
                    />
                  )}
                  name="img_file"
                  defaultValue={[]}
                />
              </div>
            </div>
          </div>
          {/* <div className="row_wrap">
            <div className="row_left">
              <div className="input_warp">
                <div className="left_box">Active (For Redeem)</div>
                <div className="right_box">
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <Inputs.InputSwitch
                        {...field}
                        errors={errors.is_active?.message}
                      />
                    )}
                    name="is_active"
                    defaultValue={false}
                  />
                </div>
              </div>
            </div>

            <div className="row_right">
              <div className="input_warp">
                <div className="left_box">Active Passcode</div>
                <div className="right_box">
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <Inputs.InputSwitch
                        {...field}
                        errors={errors.is_single_passcode_active?.message}
                      />
                    )}
                    name="is_single_passcode_active"
                    defaultValue={false}
                  />
                </div>
              </div>
              <div className="input_warp">
                <div className="left_box">Active QR Code</div>
                <div className="right_box">
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <Inputs.InputSwitch
                        {...field}
                        errors={errors.is_qr_code_active?.message}
                      />
                    )}
                    name="is_qr_code_active"
                    defaultValue={false}
                  />
                </div>
              </div>
            </div>
          </div> */}
          <div className="input_warp">
            <div className="left_box">Active Passcode</div>
            <div className="right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputSwitch
                    {...field}
                    errors={errors.is_single_passcode_active?.message}
                  />
                )}
                name="is_single_passcode_active"
                defaultValue={false}
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Active QR Code</div>
            <div className="right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputSwitch
                    {...field}
                    errors={errors.is_qr_code_active?.message}
                  />
                )}
                name="is_qr_code_active"
                defaultValue={false}
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">
              Show at reward list <br />
              Redeemed by Passcode
            </div>
            <div className="right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputSwitch
                    {...field}
                    errors={errors.is_privilege_active?.message}
                  />
                )}
                name="is_privilege_active"
                defaultValue={false}
              />
            </div>
          </div>
          <div className="input_warp">
            <div className="left_box">Active</div>
            <div className="right_box">
              <Controller
                control={control}
                render={({ field }) => (
                  <Inputs.InputSwitch
                    {...field}
                    errors={errors.is_active?.message}
                  />
                )}
                name="is_active"
                defaultValue={false}
              />
            </div>
          </div>

          {initialValues && initialValues.is_qr_code_active && (
            <div className="input_warp">
              <div className="left_box">QR code</div>
              <div className="right_box">
                {/* ไม่ตั้ง id ให้ QRCode เพราะเป็น id ตายตัว ถ้าวันไหนวางหลายใบในหน้าเดียว
                    id จะซ้ำกัน แล้ว getElementById จะหยิบใบแรกเสมอ — ถ้าต้องอ้างถึงให้ใช้ ref */}
                <QRCode
                  title="Yamaha activity qrcode"
                  value={`/${initialValues._id}/e-voucher`}
                  size={156}
                />
              </div>
            </div>
          )}
          <div className="btn_zone">
            <div className="w120">
              <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
            </div>
            {permission && (
              <>
                {initialValues && permission.is_delete && (
                  <div className="w120">
                    <Buttons.BgStandard
                      theme_red
                      label="Delete"
                      onClick={onDelete}
                      disabled={!initialValues.is_edit}
                    />
                  </div>
                )}
                {initialValues && permission.is_update ? (
                  <div className="w120">
                    <Buttons.BgStandard
                      type="submit"
                      label="Update"
                      // disabled={initialValues && initialValues.is_center}
                    />
                  </div>
                ) : (
                  permission.is_create && (
                    <div className="w120">
                      <Buttons.BgStandard
                        type="submit"
                        label="Save"
                        // disabled={initialValues && initialValues.is_center}
                      />
                    </div>
                  )
                )}
              </>
            )}
          </div>
        </div>
      </form>
    </RewardFormStyled>
  );
};

RewardForm.propTypes = {};

export default RewardForm;
